/*  MUI  */
import { Skeleton, TableCell, TableRow } from '@mui/material';

/*  React  */
import React from 'react';

export const ManagedTableSkeletonRows = ({
    colSpan,
    rowHeight,
    rowsPerPage
}) => {
    const skeletonCells = [];
    for (let x = 0; x < colSpan; x += 1) {
        skeletonCells.push(
            <TableCell key={`skeleton_cell_colSpan_${x}`}>
                <Skeleton
                    height={rowHeight ? rowHeight - 12 : '32px'}
                    animation="wave"
                />
            </TableCell>
        );
    }

    const skeletonBody = [];
    for (let x = 0; x < rowsPerPage; x += 1) {
        skeletonBody.push(
            <TableRow
                sx={{
                    backgroundColor: 'table.rowBackground',
                    minHeight: rowHeight || '32px',
                    overflow: 'hidden'
                }}
                key={`skeleton_cell_row_${x}`}
            >
                {skeletonCells}
            </TableRow>
        );
    }

    return skeletonBody;
};
